import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService }                        from '@ngx-translate/core';

// Back and forward arrows for any screen that steps through periods; the caller owns the date
@Component({
  selector   : 'wor-date-nav',
  styles: [require('./date-nav.component.scss')],
  template: require('./date-nav.component.html')
})
export class DateNavComponent {
  @Input() isDisabled         : boolean = false;
  @Input() isNextDisabled     : boolean = false;
  @Input() isPreviousDisabled : boolean = false;

  @Output() next     : EventEmitter<void> = new EventEmitter<void>();
  @Output() previous : EventEmitter<void> = new EventEmitter<void>();

  constructor (
    private translateService : TranslateService
  ) {}

  get nextTitle () : string {
    return this.translateService.instant('GENERAL_SPACE.BUTTON.NEXT');
  }

  get previousTitle () : string {
    return this.translateService.instant('GENERAL_SPACE.BUTTON.PREVIOUS');
  }
}
